import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
// import { Provider } from "react-redux";
// import {store} from "./store.tsx"
// import * as serviceWorker from './public/service-worker.js'
const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  // <Provider store={store}>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </Provider>
);
// serviceWorker.register();
